export const ReferencePeriodTableColumns = {
  GROUP_COLUMNS: 'Columns',
  REFERENCE_PERIOD: 'Reference Period',
  AVAILABLE_TIME: 'Available Time',
  UNAVAILABLE_TIME: 'Unavailable Time',
  PRODUCTION: 'Production',
  LOST_PRODUCTION: 'Lost Production',
  CONTRACTUAL_AVAILABILITY: 'Contractual Availability',
  REFERENCE_PERIOD_HISTORY: 'Reference Period History',
  REFERENCE_PERIOD_TOTAL: 'Reference Period Total',
};

export const referencePeriodTableDefs = {
  [ReferencePeriodTableColumns.GROUP_COLUMNS]: {
    align: 'left',
    labels: [
      {
        a11yKey: 'reference_table.group_columns',
        a11yDefault: 'Columns',
      },
    ],
    cols: {
      [ReferencePeriodTableColumns.REFERENCE_PERIOD]: {
        locked: true,
        labels: [
          {
            a11yKey: 'reference_table.reference_period',
            a11yDefault: 'Reference Period',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ReferencePeriodTableColumns.AVAILABLE_TIME]: {
        labels: [
          {
            a11yKey: 'reference_table.available_time',
            a11yDefault: 'Available Time',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ReferencePeriodTableColumns.UNAVAILABLE_TIME]: {
        labels: [
          {
            a11yKey: 'reference_table.unavailable_time',
            a11yDefault: 'Unavailable Time',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ReferencePeriodTableColumns.PRODUCTION]: {
        labels: [
          {
            a11yKey: 'reference_table.production',
            a11yDefault: 'Production',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ReferencePeriodTableColumns.LOST_PRODUCTION]: {
        labels: [
          {
            a11yKey: 'reference_table.lost_production',
            a11yDefault: 'Lost Production',
          },
        ],
        cell: {
          align: 'left',
        },
      },
      [ReferencePeriodTableColumns.CONTRACTUAL_AVAILABILITY]: {
        locked: true,
        labels: [
          {
            a11yKey: 'reference_table.contractual_availability',
            a11yDefault: 'Contractual Availability',
          },
        ],
        cell: {
          align: 'left',
        },
      },
    },
  },
};

export const referencePeriodTableDefaultCols = [
  {
    id: ReferencePeriodTableColumns.GROUP_COLUMNS,
    cols: [
      {
        id: ReferencePeriodTableColumns.REFERENCE_PERIOD,
        visible: true,
      },
      {
        id: ReferencePeriodTableColumns.AVAILABLE_TIME,
        visible: true,
      },
      {
        id: ReferencePeriodTableColumns.UNAVAILABLE_TIME,
        visible: true,
      },
      {
        id: ReferencePeriodTableColumns.PRODUCTION,
        visible: true,
      },
      {
        id: ReferencePeriodTableColumns.LOST_PRODUCTION,
        visible: true,
      },
      {
        id: ReferencePeriodTableColumns.CONTRACTUAL_AVAILABILITY,
        visible: true,
      },
    ],
  },
];

export const PerformanceStateKeys = {
  CONFIG_STATE: 'configState',
};
